<template>
  <card-dialog
    v-model="modalVisible"
    max-width="500px"
    :title="$t('card_dialog.support.title')"
  >
    <v-card-text
      class="pa-6"
    >
      <v-row
        class="flex-column"
        align="center"
      >
        <v-col class="py-2">
          <v-btn
            block
            text
            class="text-none justify-start"
            @click="openLink('https://www.ultrax.ai/submit-a-ticket/')"
          >
            <v-icon
              left
              color="primary"
            >
              fa-brands fa-wpforms
            </v-icon>
            {{ $t('card_dialog.support.form') }}
          </v-btn>
        </v-col>
        <v-col class="py-2">
          <v-btn
            block
            text
            class="text-none justify-start"
            @click="openLink('https://wa.me/385991688461')"
          >
            <v-icon
              left
              color="green"
            >
              fab fa-whatsapp
            </v-icon>
            {{ $t('card_dialog.support.whatsapp') }}
          </v-btn>
        </v-col>
        <v-col class="py-2">
          <v-btn
            block
            text
            class="text-none justify-start"
            target="_blank"
            :href="'mailto:support@ultrax.ai?subject=Support Request&body=Please describe your issue in detail.'"
          >
            <v-icon
              left
              color="primary"
            >
              fa-light fa-envelopes
            </v-icon>
            {{ $t('card_dialog.support.email') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </card-dialog>
</template>
<script>

import CardDialog from '@/components/helpers/CardDialog.vue'
import { EventBus } from '@/plugins/bus'

export default {
  name: 'SupportDialog',
  components: { CardDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  created() {
    EventBus.$on(this.$events.OPEN_DIALOG_SUPPORT, () => {
      this.modalVisible = true
    })
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>

</style>
